module.exports = __webpack_public_path__ + "img/svn.9f9dcee5.jpg";